import { Package } from '../roaming/RoamingInterfaces';
import { Segment } from '../stores/SegmentStore';
import { stripTrailingZeroes, replaceDotsAndFormatToTwoDecimalPlacesRoundingUp } from './PriceUtil';
import { Language } from '../stores/LanguageStore';

export const getPackagePriceForSegment = (roamingPackage: Package, segment: Segment) => {
  const priceString = segment === 'PRIVATE' ? roamingPackage.priceWithVAT : roamingPackage.price;
  return stripTrailingZeroes(replaceDotsAndFormatToTwoDecimalPlacesRoundingUp(priceString));
};

export const getSmsMessageContent = (roamingPackage: Package, currentLanguage: Language) => {
  const keyWord = currentLanguage === 'ru' ? roamingPackage.rusKeywords[0] : roamingPackage.estKeywords[0];
  return `${keyWord} ${roamingPackage.isoCode}`;
};
